<script setup>
import Clips from "@components/explore/Clips.vue";
import CountryInfo from "@components/explore/CountryInfo.vue";
import FeaturedActivities from "@components/explore/FeaturedActivities.vue";
import ToggleControls from "@components/explore/ToggleControls.vue";
import BehindTheScenes from "@components/explore/BehindTheScenes.vue";
</script>

<template>
    <div class="contents">
        <Clips />
        <CountryInfo />
        <FeaturedActivities />
        <ToggleControls />
        <BehindTheScenes />
    </div>
</template>
